/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { updateAgendaControllerUpdate } from '../fn/update-agenda/update-agenda-controller-update';
import { UpdateAgendaControllerUpdate$Params } from '../fn/update-agenda/update-agenda-controller-update';

@Injectable({ providedIn: 'root' })
export class UpdateAgendaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateAgendaControllerUpdate()` */
  static readonly UpdateAgendaControllerUpdatePath = '/thalea-google-events/update-agenda/{tenant}/{email}';

  /**
   * Update user agenda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAgendaControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgendaControllerUpdate$Response(params: UpdateAgendaControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAgendaControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update user agenda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAgendaControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgendaControllerUpdate(params: UpdateAgendaControllerUpdate$Params, context?: HttpContext): Observable<void> {
    return this.updateAgendaControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
